/* eslint-disable no-console */
import axios from 'axios';
import { LOG, BASE_URL, ADMIN_TOKEN_KEY } from 'config/constants';

const getUrl = (url: string): string => {
  return BASE_URL.concat('/').concat(url);
};

const _createHeaders = () => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  return {
    Authorization: `Bearer ${token}`,
  };
};

const _handleError = (error: any, reject: (reason: any) => void) => {
  if (error.response && error.response.data) {
    if (LOG) {
      console.log(error.response.data);
    }
    reject(error.response.data);
    return;
  }
  if (LOG) {
    console.log(error);
  }
  reject(error);
};

const _checkResponse = (data?: { success?: boolean; code: string | number }) => {
  if (!data || !data.success || data.code !== 200) {
    throw new Error('Malformed Response');
  }
};

export const GET = <SuccessDataType>(
  url: string,
  options?: CustomTypes.AxiosHelperOptions,
): Promise<SuccessDataType> => {
  if (LOG) {
    console.log('GET URL:', url, options);
  }
  return new Promise((resolve, reject) => {
    const headers = _createHeaders();
    axios
      .get(getUrl(url), { headers, ...options })
      .then(({ data }) => {
        _checkResponse(data);
        if (LOG) {
          console.log('Success:', data.data);
        }
        resolve(data.data);
      })
      .catch((error) => {
        _handleError(error, reject);
      });
  });
};

export const POST = <SuccessDataType>(
  url: string,
  body?: any,
  options?: CustomTypes.AxiosHelperOptions,
): Promise<SuccessDataType> => {
  if (LOG) {
    console.log('POST URL:', url, ',body: ', body);
  }
  return new Promise((resolve, reject) => {
    const headers = _createHeaders();
    axios
      .post(getUrl(url), body, { headers, ...options })
      .then(({ data }) => {
        _checkResponse(data);
        if (LOG) {
          console.log('Success:', data.data);
        }
        resolve(data.data);
      })
      .catch((error) => {
        _handleError(error, reject);
      });
  });
};

export const PUT = <SuccessDataType>(url: string, body: any): Promise<SuccessDataType> => {
  if (LOG) {
    console.log('PUT URL:', url, ',body: ', body);
  }
  return new Promise((resolve, reject) => {
    const headers = _createHeaders();
    axios
      .put(getUrl(url), body, { headers })
      .then(({ data }) => {
        _checkResponse(data);
        if (LOG) {
          console.log('Success:', data.data);
        }
        resolve(data.data);
      })
      .catch((error) => {
        _handleError(error, reject);
      });
  });
};

export const DELETE = <SuccessDataType>(url: string): Promise<SuccessDataType> => {
  if (LOG) {
    console.log('DELETE URL:', url);
  }
  return new Promise((resolve, reject) => {
    const headers = _createHeaders();
    axios
      .delete(getUrl(url), { headers })
      .then(({ data }) => {
        _checkResponse(data);
        if (LOG) {
          console.log('Success:', data.data);
        }
        resolve(data.data);
      })
      .catch((error) => {
        _handleError(error, reject);
      });
  });
};
